/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { PromoTemplateContext } from 'bundles/promo-template/contexts/PromoTemplateContext';

type Props = {
  msg: string;
};

const styles = css`
  color: var(--cds-color-white-0);
  background-color: #f00;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
`;

/**
 * Note: This component is used for content author only and is only rendered in preview mode.
 * So it intentionally does not use CDS to make it ugly and stand out.
 */
function NativeError({ msg }: Props) {
  const { isPreview } = React.useContext(PromoTemplateContext);

  // only render in preview mode
  if (!isPreview) {
    return null;
  }

  return (
    <div css={styles}>
      <h2>PromoTemplate - Native</h2>
      <p>{msg}</p>
    </div>
  );
}

export default NativeError;
